function calculatePercentChange(current, previous) {
    return {
        change: Math.round(((current - previous) * 100) / (previous || 1)),
        changeSuffix: "%",
    };
}

/**
 @param name {string}
 @param feed {{current: number, previous: number}}
 @param options {{decorateWith?: string|number, hasPreviousRange: boolean}}

 decorateWith is a 0, to not change current value by default, but it can be string
 to change input to string, but add decorated symbol after the value
 */
export function statFactory(
    name,
    feed,
    { decorateWith = 0, hasNoPreviousRange = true, calculateChange } = {}
) {
    const { current, previous } = feed || { current: 0, previous: 0 };
    const { change, changeSign } = calculateChange
        ? calculateChange(current, previous)
        : calculatePercentChange(current, previous);
    return {
        name,
        value: current + decorateWith,
        prev_value: hasNoPreviousRange ? 0 : previous.toString(),
        change: hasNoPreviousRange ? 0 : change,
        changeSign,
    };
}
